export const APP_LOCALE_COOKIE = "cv_app_locale";

export const appLocales = ["en", "fr"] as const;

export type AppLocale = (typeof appLocales)[number];

export function isAppLocale(value: string | undefined): value is AppLocale {
  return appLocales.some((locale) => locale === value);
}

/**
 * Writes the app-wide locale cookie from outside AppLocaleProvider — e.g. a marketing
 * page CTA that navigates into the tenant app should carry its locale forward, since the
 * two surfaces don't share a locale mechanism otherwise.
 */
export function persistAppLocaleCookie(locale: AppLocale): void {
  document.documentElement.lang = locale;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${APP_LOCALE_COOKIE}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
}
